import { Route, Routes, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import './base-theme.css';
import './App.css';
import { SiteFooter } from './components/SiteFooter';
import { SiteHeader } from './components/SiteHeader';
import { AboutPage } from './pages/AboutPage';
import { BlogPage } from './pages/BlogPage';
import { ExperiencePage } from './pages/ExperiencePage';
import { HomePage } from './pages/HomePage';

const pageTitles = {
  '/': 'Eli Schatz .com',
  '/blog': 'Blog | Eli Schatz',
  '/experience': 'Experience | Eli Schatz',
  '/about': 'About | Eli Schatz',
};

function DocumentTitle() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = pageTitles[pathname] ?? 'Eli Schatz';
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="site-shell">
      <DocumentTitle />
      <SiteHeader />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/experience" element={<ExperiencePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </main>
      <SiteFooter />
    </div>
  );
}

export default App;
